/*jshint esversion:6 */
import React from "react";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Constants from "../../../configurations/constants";
import ArbiterApi from "../../../api/ArbiterApi";
import TransactionGroupsTable from "./transactionGroupsTable";
import TransactionGroupsModal from "./transactionGroupsModal";

class TransactionGroupsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      transactionGroups: [],
      selectedTransactionGroup: null,
      totalCount: 0,
      loading: false,
      pages: 0,
      openModalFlag: false,
      createFlag: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0 //Zero based index
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onNewButtonClick = this.onNewButtonClick.bind(this);
    this.paginateid = this.paginateid.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    // const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  componentDidMount() {
    //Load data on mount
    this.reloadGroups();
  }

  onNewButtonClick(evt) {
    this.setState({ openModalFlag: true, createFlag: true });
  }

  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Transaction Groups" />
        <Divider />
        <div className="mini-filter align-right">
          <button onClick={this.onNewButtonClick} className="btn btn-primary">
            + New Transaction Group
          </button>
        </div>
        <TransactionGroupsTable
          onRowClick={this.onRowClick}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          transactionGroups={this.state.transactionGroups}
          paginatedCallBack={this.paginateid}
        />
        {this.state.openModalFlag && (
          <TransactionGroupsModal
            isNew={this.state.createFlag}
            isOpen={this.state.openModalFlag}
            onRequestClose={this.handleCloseModal}
            transactionGroup={this.state.selectedTransactionGroup}
          />
        )}
      </div>
    );
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadGroups(params);
    }
  }

  loadGroups(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    ArbiterApi.getPaginatedTransactionGroups(params)
      .then(response => {
        let data = response.data.content;
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Transaction Groups");
        this.setState({
          transactionGroups: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_TRANSACTION_GROUPS}`
        ]);
        this.setState({ loading: false });
      });
  }

  onRowClick(index) {
    this.setState({
      selectedTransactionGroup: this.state.transactionGroups[index],
      openModalFlag: true,
      createFlag: false
    });
  }
  handleCloseModal(event, reloadDataFlag) {
    this.setState({
      selectedTransactionGroup: null,
      openModalFlag: false,
      createFlag: false
    });
    if (reloadDataFlag) {
      this.reloadGroups();
    }
  }

  reloadGroups() {
    this.setState({ transactionGroups: [] });
    this.loadGroups({ pageSize: this.state.pageSize });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(TransactionGroupsPage, [Permissions.VIEW_TRANSACTION_GROUP])
);



// WEBPACK FOOTER //
// ./src/components/admin/transactionGroups/transactionGroupsPage.js